import { InsuranceCardSide } from '../types/insuranceTypes'

export const COVERAGE_INSURANCE_CARD_EXTENSION_URLS: Record<InsuranceCardSide, string> = {
  front: 'https://behuman.health/coverage-insurance-card-front',
  back: 'https://behuman.health/coverage-insurance-card-back',
}

export const INSURANCE_CARD_SIDES: InsuranceCardSide[] = ['front', 'back']

export const COVERAGE_TYPES = [
  { label: 'Self', value: 'self' },
  { label: 'Spouse', value: 'spouse' },
  { label: 'Child', value: 'child' },
  { label: 'Other', value: 'other' },
]

export const INSURANCE_RANKS = [
  { value: 'Primary', label: 'Primary' },
  { value: 'Secondary', label: 'Secondary' },
  { value: 'Tertiary', label: 'Tertiary' },
]

export const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/png'] as const

export const INSURANCE_CARD_DISPLAY: Record<
  InsuranceCardSide,
  { label: string; helper: string; placeholder: string }
> = {
  front: {
    label: 'Front of card',
    helper: 'Member-facing side',
    placeholder: 'Front of the insurance card is not attached.',
  },
  back: {
    label: 'Back of card',
    helper: 'Plan details side',
    placeholder: 'Back of the insurance card is not attached.',
  },
}
